/** Small wording helpers for announcements and screen-reader text. */

/**
 * End a phrase with exactly one terminal mark: "Alex passed" → "Alex passed.",
 * while "… for 75 — bingo!" stays as it is (never "bingo!.").
 */
export function sentence(text: string): string {
  const trimmed = text.trimEnd();
  if (trimmed === '' || /[.!?…]$/.test(trimmed)) return trimmed;
  return `${trimmed}.`;
}
